/***
 *
 * NB that the "_SUCCESS" suffixed actions are used to handle successful api calls.
 * NB - actions with the suffix `SUCCESS` are used to save data return from api calls.
 */

// Representative
export const GET_REPRESENTATIVES_SUCCESS = 'GET_REPRESENTATIVES_SUCCESS';
export const GET_CUSTOMER_REPRESENTATIVES_SUCCESS = 'GET_CUSTOMER_REPRESENTATIVES_SUCCESS';
export const GET_COMPANY_REPRESENTATIVES_SUCCESS = 'GET_COMPANY_REPRESENTATIVES_SUCCESS';
export const GET_REPRESENTATIVE_SUCCESS = 'GET_REPRESENTATIVE_SUCCESS';
export const UPDATE_REPRESENTATIVE_SUCCESS = 'UPDATE_REPRESENTATIVE_SUCCESS';

export const SET_PANEL = 'SET_PANEL';
